import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  Icon,
  InputGroup,
  Spinner,
  Switch,
  Tab,
  Tabs,
  TextArea,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel } from "mobx-utils";
import * as React from "react";
import { api_adm } from "../../api";
import { IProduto } from "../../model";
import { ProdutoStore } from "../../stores/legislacao/ProdutoStore";
import { toast } from "react-toastify";
import { DateInput } from "@blueprintjs/datetime";
import { getMomentFormatter } from "../../utils";
import MomentLocaleUtils from "react-day-picker/moment";
import moment from "moment";

interface ProdutoDialogProps {
  produto: IProduto;
  onClose: () => void;
  estado: string;
}

interface ProdutoDialogState {
}

@observer
export class ProdutoDialog
  extends React.Component<ProdutoDialogProps, ProdutoDialogState> {
  obs = observable({
    produto: {} as IProduto
  })

  async componentDidMount() {
    this.obs.produto = createViewModel(observable(this.props.produto));
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleSave = async () => {
    try {
      this.obs.produto.estado = this.props.estado

      let resp = null
      
      if (this.obs.produto.id) {
        resp = await api_adm.put(`/api/admin/produtos/${this.obs.produto.id}`, this.obs.produto);
      } else {
        resp = await api_adm.post("/api/admin/produtos", this.obs.produto);
      }

      if(resp.data.ok) {

        toast.success('Produto atualizado', {});

        let entrada_saida: string = this.obs.produto.entrada ? "entrada" : "saida";
      
        await ProdutoStore.loadProdutos(1, ProdutoStore.obs.filter, entrada_saida, this.props.estado)
        
        this.props.onClose();

      }

    } catch (ex) {
    
      toast.error(`Erro ao atualizar Produto!`, {});
    
    }

  };

  renderData() {
    let dayPickerProps = {
              localeUtils: MomentLocaleUtils,
              locale: "pt-br",
            };
    return (
      <div>
        <FormGroup
          label="Descrição"
          labelFor="descricao"
        >
          <TextArea
            id="descricao"
            style={{ width: "100%" }}
            value={this.obs.produto.descricao}
            onChange={(e: any) => this.obs.produto.descricao = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="NCM"
          labelFor="ncm"
        >
          <InputGroup
            id="ncm"
            style={{ width: "50%" }}
            value={this.obs.produto.ncm}
            onChange={(e: any) => this.obs.produto.ncm = e.target.value}
          />
        </FormGroup>

        <FormGroup
          label="CEST"
          labelFor="cest"
        >
          <InputGroup
            id="cest"
            style={{ width: "50%" }}
            value={this.obs.produto.cest}
            onChange={(e: any) => this.obs.produto.cest = e.target.value}
          />
        </FormGroup>

        <FormGroup label="Validade" labelFor="validade">
          <div style={{ width: 600, display: "flex", alignItems: "center" }}>
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_de}
              onChange={val => {
                this.obs.produto.valido_de = val;

                if (
                  this.obs.produto.valido_ate &&
                  moment(val).isAfter(moment(this.obs.produto.valido_ate))
                ) {
                  this.obs.produto.valido_ate = null; 
                  toast.warning("A data inicial não pode ser maior que a final.");
                }
              }}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
            <Icon icon="arrow-right" style={{ margin: "0 10px" }} />
            <DateInput
              {...getMomentFormatter("DD/MM/YYYY")}
              locale="pt-br"
              dayPickerProps={dayPickerProps}
              value={this.obs.produto.valido_ate}
              onChange={val => {
                this.obs.produto.valido_ate = val;

                if (
                  this.obs.produto.valido_de &&
                  moment(val).isBefore(moment(this.obs.produto.valido_de))
                ) {
                  this.obs.produto.valido_ate = null;
                  toast.warning("A data final não pode ser menor que a inicial.");
                }
              }}
              placeholder="DD/MM/AAAA"
              canClearSelection
            />
          </div>
        </FormGroup>

        <Switch
          checked={this.obs.produto.entrada}
          onChange={(e: any) => this.obs.produto.entrada = e.target.checked}
          innerLabelChecked="Entrada" innerLabel="Saída"
          style={{ marginTop: 12, marginLeft: "auto", fontSize: 12, fontWeight: 600 }}
        />

      </div>
    );
  }

  render() {

    return (
      <Dialog
        isOpen={true}
        title="Editando Produto"
        onClose={this.props.onClose}
        style={{ width: 800, height: 600 }}
      >
        <div className={Classes.DIALOG_BODY}>
          {this.obs.produto && this.renderData() || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={this.props.onClose} />
            <Button text="Salvar" intent="primary" onClick={this.handleSave} />
          </div>
        </div>
      </Dialog>
    );
  }
}
